<template>
    <div @click="close" class="email-selection-page">
        <div v-on:click.stop class="email-page-container">
            <p class="close-bulk" @click="close">&lt; back to select gifts</p>
            <EmailSelection @next="next($event)" :product="product" v-if="step == 1"/>
            <EmailConfiguration @end="end" :product="product" :emailFile="emailFile" @next="next($event)" v-else/>
        </div>
    </div>
</template>

<script>
import EmailSelection from './EmailSelection.vue'
import EmailConfiguration from './EmailConfiguration.vue'
export default {
    components:{
        EmailSelection,
        EmailConfiguration
    },
    data(){
        return{
            step: 1,
            emailFile: null
        }
    },
    props:{
        product: Object,
    },
    computed:{

    },
    methods:{
        close(){
            this.$emit("close");
        },
        next(files){
            this.emailFile = files;
            this.step = 2;
        },
        end(file){
            this.$emit("end",file);
        }
    }
}
</script>

<style scoped>
.email-selection-page{
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    background-color: #0000001a;
    display: flex;
    align-items: center;
    justify-content: center;
}

.email-page-container{
    width: 80%;
    height: 80%;
    border: 1px solid black;
    border-radius: 4px;
    background-color: white;
    overflow-y: scroll;
}

.close-bulk{
    font-size: 1.2vw;
    position: absolute;
    top: -2vh;
    left: 0%;
    z-index: 1;
    cursor: pointer;
  }
</style>